import React, { Component } from "react";
import "./style.css";
import Payout from "../../../Images/packageBanner.jpg";

class Training extends Component {
  render() {
    return (
      <div className="faqMainBox animate__animated animate__fadeIn">
        <img className="payoutimg" src={Payout} alt="WORK Payout" />
      </div>
    );
  }
}
export default Training;
